import { render, staticRenderFns } from "./modalRegistarPago.vue?vue&type=template&id=aee840e6&"
import script from "./modalRegistarPago.vue?vue&type=script&lang=js&"
export * from "./modalRegistarPago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports